const en = {
  translation: {
    welcome: 'Welcome to',
    explore:
      'Explore the NBAVerse with a map of NBA clubs, team tables, player search bar, and live statistics.',
    getStarted: 'Get Started',
    alreadyHaveAccount: 'Already got an account?',
    mapPageTitle: 'Map Page',
    mapDescription:
      'Interactive map displaying the locations of NBA clubs for easy navigation.',
    goToMap: 'Go to Map',
    mapImageAlt: 'Map of NBA Clubs',
    name: 'Name',
    namePlaceholder: 'Enter your name',
    email: 'Email',
    emailPlaceholder: 'Enter your email',
    password: 'Password',
    passwordPlaceholder: 'Enter your password',
    confirmPassword: 'Confirm Password',
    confirmPasswordPlaceholder: 'Confirm your password',
    register: 'Register',
    signUpWithGithub: 'Sign up with Github',
    registrationSuccess: 'Registration successful!',
    registrationFailed: 'Registration failed',

    teams: 'teams',
    teamPage: 'Teams Page',
    teamPageDescription:
      'Here you can search for NBA teams you are interested in and learn more about them.',
    previous: 'Previous',
    next: 'Next',
    cancel: 'Cancel',
    goToTeams: 'Go to Teams Page',
    nbaGames: 'NBA Games',
    allTeams: 'All Teams',
    loadingGames: 'Loading games...',
    errorLoadingGames: 'Error loading games',
    previousPage: 'Previous page',
    nextPage: 'Next page',
    vs: 'VS',
    Role: 'Role',
    cre: 'Create',
    CreNewUser: 'Create a new user',
    soon: 'SOON',
    winner: 'Winner',
    filterByConference: 'Filter by Conference',
    easternConference: 'Eastern Conference',
    westernConference: 'Western Conference',
    loadingTeams: 'Loading teams...',
    login: 'Login',
    signInWithGithub: 'Sign in with Github',
    logoutSuccessful: 'loged out successful!',
    loginSuccess: 'Login successful!',
    loginFailed: 'Login failed. Please check your credentials.',

    playersPage: 'Players Page',
    playersPageDescription:
      'Use the Players Search Bar to find detailed informations about your favorite NBA players.',
    seeMore: 'See More',
    GameFinal: 'ended',
    team: 'Team',
    city: 'City',
    conference: 'Conference',
    division: 'Division',
    PanelUser: 'User panel menagment',
    teamPageDescriptionSolo:
      'Learn about the history of the team, its city, conference, and division.',
    teamHistory: 'Team History',
    noHistory: 'No history available for this team.',
    finalStatus: 'Final',
    dontHaveAccount: "Don't have an account?",
    registerHere: 'Register here',
    loginHere: 'Login here',
    teamsList: 'teams list',
    teamsTable: 'teams table',
    search: 'search',
    action: 'action',
    Edituser: 'Edit user',
    Edit: 'Edit',
    delete: 'delete',
    CreateUser: 'create a new user',
    clearResults: 'Clear Results',

    footer: {
      title: 'NBAVerse.',
      description: 'Piotr Fedak Thesis',
      copyright: 'All rights reserved',
      socialTitle: 'Social',
      linksTitle: 'Links',
      home: 'Home',
      map: 'Map',
      teams: 'Teams',
      players: 'Players',
    },

    auth: {
      loginNow: 'Login now!',
      registerNow: 'Register now!',
      nbaverseAccount:
        'By creating an account on NBAVerse, you can add your favorite teams and easily track changes in the NBA!',
      userReply: 'Oh really? I’m signing up now!',
      chatTime: 'Time',
      delivered: 'Delivered',
      seenAt: 'Seen at',
    },
  },
};

export default en;
